import { createContext } from 'react'

import { makeUrlStateContext } from '@percept/hooks'

import { DataWarehouseReportGrouping, DataWarehouseAvailabilityResponse } from 'components/DataWarehouse'

import { AnyPerformanceDimension, Nullable } from '@percept/types'


export type DashboardDimension = AnyPerformanceDimension | 'potential_efficiency'

export type DashboardUrlParams = { currency: string, dimension: DashboardDimension }

export const DashboardContext = makeUrlStateContext<DashboardUrlParams>()


export type OverviewPerformanceDimension = AnyPerformanceDimension

export const PerformanceOverviewContext = makeUrlStateContext<{ currency: string, dimension: OverviewPerformanceDimension }>()


export type OrgUnitDataWarehouseAvailabilityContextValue = Nullable<{
  reportGroupings: DataWarehouseReportGrouping[]
  availability: DataWarehouseAvailabilityResponse[]
}>

export const OrgUnitDataWarehouseAvailabilityContext = createContext<OrgUnitDataWarehouseAvailabilityContextValue>({
  reportGroupings: null,
  availability: null,
})

export type OrgUnitHomePageUrlParams = {
  range: '1-day' | '7-days' | '30-days' | 'this-month' | 'this-quarter' | 'this-year'
}

export const OrgUnitHomePageContext = makeUrlStateContext<OrgUnitHomePageUrlParams>()
